module.exports = __webpack_public_path__ + "static/media/star-icon.53b157c3.svg";